import { AdSet } from '../../../entities/ad-set';
import { Event } from '../event';

export class AdSetResolveEvent extends Event {
  private render = true;

  constructor (private readonly id: string, private readonly adSet?: AdSet) {
    super();
  }

  public getId (): string {
    return this.adSet?.getId() ?? this.id;
  }

  public getAdSet (): AdSet | null {
    return this.adSet ?? null;
  }
}
